import type { RelatedPersonType } from '@models/related-person';

import { FAMILY_HISTORY_RELATIONSHIP_MAP } from './family-history';

export const RELATED_PERSON_MAP: Record<RelatedPersonType, string> = {
  'legal-counsel': 'Legal Counsel',
  'power-of-attorney': 'Power of Attorney',
  'emergency-contact': 'Emergency Contact',
  'secondary-emergency-contact': 'Secondary Emergency Contact',
};

const FAMILY_HISTORY_RELATIONS = Object.entries(
  FAMILY_HISTORY_RELATIONSHIP_MAP
).reduce<Record<string, string>>((acc, curr) => {
  {
    const [k, v] = curr;
    acc[k] = v.display;
    return acc;
  }
}, {});

export const RELATED_PERSON_RELATIONSHIP_MAP: Map<string, string> = new Map(
  Object.entries({
    C: 'Emergency Contact',
    E: 'Employer',
    F: 'Federal Agency',
    I: 'Insurance Company',
    N: 'Next-of-Kin',
    O: 'Other',
    S: 'State Agency',
    U: 'Unknown',
    FRND: 'unrelated friend',
    NBOR: 'neighbor',
    ONESELF: 'self',
    ROOM: 'Roommate',
    POWATT: 'power of attorney',
    DPOWATT: 'durable power of attorney',
    HPOWATT: 'healthcare power of attorney',
    SPOWATT: 'special power of attorney',
    ...FAMILY_HISTORY_RELATIONS,
    'legal-counsel': 'Legal counsel',
  })
);
